import { render, staticRenderFns } from "./Selection.vue?vue&type=template&id=1872b5f0&scoped=true"
import script from "./Selection.vue?vue&type=script&lang=js"
export * from "./Selection.vue?vue&type=script&lang=js"
import style0 from "./Selection.vue?vue&type=style&index=0&id=1872b5f0&prod&scoped=true&lang=scss"
import style1 from "./Selection.vue?vue&type=style&index=1&id=1872b5f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1872b5f0",
  null
  
)

export default component.exports